import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,Label,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input
} from "reactstrap"
import {
    AvField,
    AvForm
} from "availity-reactstrap-validation";
import { Table, Thead, Tbody, Tr, Th, Td, } from "react-super-responsive-table"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/presensiService"

import IndexBloc from "../Blocs/IndexBlock"
import apiResponse from '../../../../../services/apiResponse'
import Select from "react-select"
import moment from "moment"
import DataTableBloc from "../Blocs/DataTableBloc"

var reformatOptions = function (raw, label, value) {
    return raw.map(function (data) {
        var newObj = {};
        newObj["label"] = data[label];
        newObj["value"] = data[value];
        
        return newObj;
    });
}; 
class TableSecondComponent extends Component {
    indexBloc = new IndexBloc()
    dataTableBloc = new DataTableBloc()
    
    source
    Table = 'mutasirekomendasidiproses'
    defaultOrder = 'employee_transfer_detail_create_date'
    defaultSize = 10
    defaultSort = 'asc'
    
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }
    constructor(props) {
        super(props)
        this.state = {
            loadingTable: false,
            cancelDate: null,
            rows: [],
            tooltip: false,
            detailUuid: null,
            defaultSize: 10,
            totalRow: 0,
            loadingTable: false,
            positionOption: [],
            employeeOption: [],
            employee_transfer_detail_uuid: '',
            wuAll: [{}],
            workunitfilter: '',
            dataForm: {},
            filter: sessionStorage.getItem(this.Table) ?
                JSON.parse(sessionStorage.getItem(this.Table)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }
    
    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });
    loadData_ = async () => {
        this.setState({
            loadingTable: true
        });
        var additionalFilter = {
            ...this.props.additionalFilter,
            workunitfilter: this.state.workunitfilter
        };
        this.dataTableBloc.fetchRowTableHistory(additionalFilter);
    }
    loadData = async () => {
        this.setState({
            loadingTable: true
        });
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number - 1) * this.state.filter.page_size
        if (this.state.defaultSize !== this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            workunitfilter: this.state.workunitfilter,
            month_filter: this.state.month_filter,
            year_filter: this.state.year_filter,
            status: 1
        }
        await this.dataTableBloc.fetchRowTableHistory(query, this.source.token);
    }
    do_export = async () => {
        this.setState({
            loading: true
        });
        var workunitfilter = this.state.workunitfilter
        this.dataTableBloc.fetchExport({'workunit_uuid':workunitfilter});
    }
    
    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }
    delmapping = (param) => {
        this.setState({
            confirm:true,
            employee_transfer_detail_uuid : param
        })
    }
    handlerOnSubmit = (e, values) => {
        e.preventDefault();
        if (!values.no_sk || !values.tgl_sk || !values.tmt_sk || !values.pejabat_penetap) {
            this.setState({
                errorwajib: true
            });
        }else{
            const allData = {
                ...values
            };
            this.setState({
                dataForm: allData,
                confirmsubmit: true
            });
        }
    }
    submitData = async () => {
        await this.dataTableBloc.fetchProses(this.state.dataForm);
    }
    
    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
                case 'confirm':
                    forState = {
                        loading: true,
                        confirm: false
                    }
                    this.dataTableBloc.fetchDelMapping({employee_transfer_detail_uuid:this.state.employee_transfer_detail_uuid});
                    break;
                    case 'success':
                        forState = {
                            success: false,
                            redirect: true
                        }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    confirmResponseSubmit = (response) => {
        let forStatesubmit = {}
        switch(response) {
            case 'cancel':
                forStatesubmit = {
                    confirmsubmit: false
                }
                break;
                case 'confirm':
                    forStatesubmit = {
                        loadingsubmit: true,
                        confirmsubmit: false
                    }
                    this.dataTableBloc.fetchProses(this.state.dataForm);
                    break;
                    case 'success':
                        forStatesubmit = {
                            successsubmit: false,
                            redirectsubmit: true
                        }
                break;
             case 'failed':
                forStatesubmit = {
                    failedsubmit: false
                }
                break;
            default:       
        }
        this.setState(forStatesubmit)
    }
    confirmResponseError = (response) => {
        let forStateerror = {}
        switch(response) {
             case 'failed':
                forStateerror = {
                    errorwajib: false
                }
                break;
            default:       
        }
        this.setState(forStateerror)
    }

    componentDidMount() {
        this.setTokenAPI()

        this.dataTableBloc.prosesChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        // selectedEmployees: [],
                        loadingsubmit: false,
                        successsubmit: true,
                    });
                    document.getElementById("myForm").reset();
                    this.loadData()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loadingsubmit: false,
                        failedsubmit: true,
                    });
                    break
                default:
                    break
            }
        })
        this.dataTableBloc.exportChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    const link = result.data.response
                    window.open(link.file_url, "_blank")
                    this.setState({
                        loading: false,
                        success: true
                    })
                    setTimeout(() => {
                        this.setState({
                            success: false,
                        })
                    }, 1000);
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.historyChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false,
                        rows: [],
                        totalRow:0
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true,
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        rows: response.result,
                        totalRow: response.total,
                        loadingTable: false,
                        wuAll: this.props.wuall.length > 0 ? [{ value: '', label: 'Semua' }, ...this.props.wuall] : [{ value: '', label: 'Tidak Ada Data' }]
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.dataTableBloc.delChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    
                    break
                case apiResponse.LOADING:
                    
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    console.log(response)
                    this.setTokenAPI()
                    this.setState({
                        loading: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.positionChannel.subscribe((result) => {
            switch (result.status) {
              case apiResponse.COMPLETED:
                console.log(result)
                this.setState({
                  positionOption: reformatOptions(
                    result.data.response.result,
                    "position_name",
                    "position_uuid"
                  ),
                  loadingPosition: false,
                });
                break;
              case apiResponse.ERROR:
                break;
              default:
                break;
            }
          })
        this.dataTableBloc.fetchPosition({});
        this.dataTableBloc.employeeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    console.log(result)
                    this.setState({
                        employeeOption: reformatOptions(
                            result.data.response.result,
                            "employee_full_name",
                            "employee_uuid"
                        ),
                        loadingEmployee: false,
                });
                break;
              case apiResponse.ERROR:
                  break;
                  default:
                      break;
                    }
                })
                this.dataTableBloc.fetchEmployee({});

            }
            
    componentWillUnmount() {
        this.dataTableBloc.historyChannel.unsubscribe()
    }
    columns = [
        {
            key: "employee_transfer_detail_employee_full_name",
            text: "Nama",
            sortable: false,
            cell: record => {
                return (
                    <div style={{ width: '200px' }}> {/* Memperbesar ukuran kolom */}
                        {record.employee_transfer_detail_employee_full_name}
                    </div>
                );
            }
        },
        {
            key: "employee_transfer_detail_old_position_name",
            text: "Jabatan",
            sortable: false,
            cell: record => {
                return (
                    <div style={{ width: '250px' }}> {/* Memperbesar ukuran kolom */}
                        {record.employee_transfer_detail_old_position_name}
                    </div>
                );
            }
        },
        {
            key: "employee_rank_group_room",
            text: "Golongan",
            sortable: false,
            cell: record => {
                return record.rank_group_room;
            }
        },
        // {
        //     key: "masa_kerja_eselon_1",
        //     text: "Masa Kerja Eselon-1",
        //     sortable: false,
        //     cell: record => {
        //         return record.masa_kerja_eselon_1 === "00:00:00" || record.masa_kerja_eselon_1.includes('-') ? "0 tahun 0 bulan 0 hari" : record.masa_kerja_eselon_1.replace(/day/, 'hari').replace(/haris/, 'hari').replace(/mon/, 'bulan').replace(/bulans/, 'bulan').replace(/year/, 'tahun').replace(/tahuns/, 'tahun'); 
        //     }
        // },
        // {
        //     key: "masa_kerja_eselon_2",
        //     text: "Masa Kerja Eselon-2",
        //     sortable: false,
        //     cell: record => {
        //         return record.masa_kerja_eselon_2 === "00:00:00" || record.masa_kerja_eselon_2.includes('-') ? "0 tahun 0 bulan 0 hari" :record.masa_kerja_eselon_2.replace(/day/, 'hari').replace(/haris/, 'hari').replace(/mon/, 'bulan').replace(/bulans/, 'bulan').replace(/year/, 'tahun').replace(/tahuns/, 'tahun'); 
        //     }
        // },
        {
            key: "masa_kerja_eselon_2",
            text: "Masa Kerja Eselon-2",
            sortable: false,
            cell: record => {
                return record.masa_kerja_eselon_2; 
            }
        },
        {
            key: "action",
            text: "",
            sortable: false,
            cell: record => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                {
                    <Button
                        className="btn btn-light"
                        type="button" 
                        disabled
                    >
                        <i className="fas fa-arrow-right text-muted text-success"></i>
                    </Button>
                }
                    </div>
                );
            }
        },
        // {
        //     key: "employee_transfer_detail_id",
        //     text: "Jabatan",
        //     sortable: true,
        //     cell: record => {
        //         return (
        //         <>
            
                
                   
        //         <Select
        //             name={`position_${record.employee_uuid}`}
        //             errorMessage="Pilih Jabatan"
        //             placeholder="Pilih Jabatan"
        //             options={this.state.positionOption}
        //             isDisabled={true}
        //             styles={{ container: (provided) => ({ ...provided, width: '200px' }) }}
        //             validate={{ required: { value: true } }}
        //             value={[{'label':record.employee_transfer_detail_position_name,'value':record.employee_transfer_detail_position_uuid}]}
        //         />
                  
        //         </>
        //         );
        //     }
        // },
        // {
        //     key: "employee_uuid",
        //     text: "Unit kerja tujuan",
        //     sortable: true,
        //     cell: record => {
        //         return (
        //             <>
                
        //         {
        //             <Select
        //                 name={`work_unit_${record.employee_uuid}`} // Menggunakan UUID pegawai sebagai nama unik
        //                 // options={this.props.wuall}
        //                 classNamePrefix="select2-unit"
        //                 styles={{ container: (provided) => ({ ...provided, width: '250px' }) }} // Memperbesar ukuran kolom
        //                 value={[{'label':record.employee_transfer_detail_work_unit_name,'value':record.employee_transfer_detail_work_unit_uuid}]}
        //                 isDisabled={true}
        //             />
        //         }
        //     </>
        //         );
        //     }
        // },
        // {
        //     key: "employee_nip",
        //     text: "Nama Pegawai Pengganti",
        //     sortable: false,
        //     cell: record => {
        //         return (
        //             <>
        //                 <Select
        //                     name={`employee_${record.employee_uuid}`} // Menggunakan UUID pegawai sebagai nama unik
        //                     // options={this.state.employeeOption}
        //                     classNamePrefix="select2-unit"
        //                     styles={{ container: (provided) => ({ ...provided, width: '150px' }) }} // Memperbesar ukuran kolom
        //                     value={[{'label':record.employee_transfer_detail_replacement_name,'value':record.employee_transfer_detail_replacement_uuid}]}
        //                     isDisabled={true}
        //                 />
        //             </>
        //         );
        //     }
        // },
        {
            key: "employee_transfer_detail_id",
            text: "Jabatan",
            sortable: false,
            cell: record => {
                return record.employee_transfer_detail_position_name;
            }
        },
        {
            key: "employee_uuid",
            text: "Unit Kerja Tujuan",
            sortable: false,
            cell: record => {
                return record.employee_transfer_detail_work_unit_name;
            }
        },
        {
            key: "employee_nip",
            text: "Nama Pegawai Pengganti",
            sortable: false,
            cell: record => {
                return record.employee_transfer_detail_replacement_name;
            }
        },
        {
            key: "action",
            text: "Action",
            sortable: false,
            cell: record => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                {
                    <Button
                        className="btn btn-danger"
                        type="button" 
                        onClick={() => {
                            this.delmapping(record.employee_transfer_detail_uuid)
                        }} 
                    >
                        <i className="fas fa-arrow-left text-white text-success"></i>
                    </Button>
                }
                    </div>
                );
            }
        },
    ]

    render() {
        return (
            <>
                <AvForm
                    id="myForm"
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                    this.handlerOnSubmit(e, values)
                    }
                >
                    <Row className="mb-3">
                        <Col md="12">
                            <Row className="mb-4">
                                <label htmlFor="gender" className="col-md-2 col-form-label">
                                Unit Kerja
                                </label>
                                <Col md="4">
                                    <Select
                                        id="wu_filter"
                                        name="wu_filter" // Menggunakan UUID pegawai sebagai nama unik
                                        required={true}
                                        options={[{ value: '', label: 'Semua' }, ...this.props.wuall]}
                                        classNamePrefix="select2-unit"// Memperbesar ukuran kolom
                                        onChange={(selectedOption) => {
                                            this.setState(prevState => ({
                                                workunitfilter: selectedOption.value
                                            }));
                                            
                                        }}
                                    />
                                </Col>
                                <Col md="3">
                                <Button
                                    className="btn btn-success"
                                    type="button" 
                                    onClick={() => {
                                        this.setTokenAPI();
                                    }} >
                                    <i className="fas fa-search text-white"></i> Cari
                                </Button>
                                &nbsp;
                                <Button
                                    className="btn btn-success"
                                    type="button" 
                                    onClick={() => {
                                        this.do_export();
                                    }} >
                                    <i className="fas fa-file-excel text-white"></i> Export
                                </Button>
                                </Col>
                            </Row>
                            {/* <Row className="mb-2">
                                <Label>Unit Kerja</Label>
                                <Col md="6">
                                    <Select
                                        id="wu_filter"
                                        name="wu_filter" // Menggunakan UUID pegawai sebagai nama unik
                                        required={true}
                                        options={[{ value: '', label: 'Semua' }, ...this.props.wuall]}
                                        classNamePrefix="select2-unit"// Memperbesar ukuran kolom
                                        onChange={(selectedOption) => {
                                            this.setState(prevState => ({
                                                workunitfilter: selectedOption.value
                                            }));
                                            
                                        }}
                                    />
                                </Col>
                                <Col md="3">
                                <Button
                                    className="btn btn-success"
                                    type="button" 
                                    onClick={() => {
                                        this.setTokenAPI();
                                    }} >
                                    <i className="fas fa-search text-white"></i> Cari
                                </Button>
                                &nbsp;
                                <Button
                                    className="btn btn-success"
                                    type="button" 
                                    onClick={() => {
                                        this.do_export();
                                    }} >
                                    <i className="fas fa-file-excel text-white"></i> Export
                                </Button>
                                </Col>
                            </Row> */}
                        </Col>
                        <Col md="6">
                            {/* <Row>
                                <Col md="3">
                                    <label htmlFor="">nomor SK</label>
                                    <AvField
                                        type="text" 
                                        name="no_sk"
                                        id="no_sk"
                                        placeholder="Nomor SK..."
                                        errorMessage="Masukkan Nomor SK"
                                        validate={{ required: { value: true } }}                                       
                                    />
                                </Col>
                                <Col md="3">
                                    <label htmlFor="">Tanggal SK</label>
                                    <AvField
                                        type="date" 
                                        name="tgl_sk"
                                        placeholder="Tanggal SK..."
                                        errorMessage="Masukkan Tanggal SK"
                                        validate={{ required: { value: true } }}                                       
                                    />
                                </Col>
                                <Col md="6">
                                    <label htmlFor="" className="text-white">label</label>
                                    <div style={{ paddingTop: '2px' }}>
                                        <Button className="btn btn-warning" style={{ marginRight: '5px' }}>Unduh SK Petikan</Button>
                                        <Button className="btn btn-info">Unduh SK Kolektif</Button>
                                    </div>
                                </Col>
                            </Row> */}
                        </Col>
                    </Row>
                    <hr />
                    <Row className="mb-3">
                        <Col md="12">
                            <Row className="mb-4">
                                <label htmlFor="gender" className="col-md-2 col-form-label">
                                    Nomor SK<span className="text-danger">*</span>
                                </label>
                                <Col md="4">
                                    <AvField
                                        type="text" 
                                        name="no_sk"
                                        id="no_sk"
                                        placeholder="Nomor SK..."
                                        errorMessage="Masukkan Nomor SK"
                                        // validate={{ required: { value: true } }}                                       
                                    />
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <label htmlFor="gender" className="col-md-2 col-form-label">
                                    Tanggal SK<span className="text-danger">*</span>
                                </label>
                                <Col md="4">
                                <AvField
                                    type="date" 
                                    name="tgl_sk"
                                    placeholder="Tanggal SK..."
                                    errorMessage="Masukkan Tanggal SK"
                                    // validate={{ required: { value: true } }}                                       
                                />
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <label htmlFor="gender" className="col-md-2 col-form-label">
                                    TMT SK<span className="text-danger">*</span>
                                </label>
                                <Col md="4">
                                <AvField
                                    type="date" 
                                    name="tmt_sk"
                                    placeholder="TMT SK..."
                                    errorMessage="Masukkan TMT SK"
                                    // validate={{ required: { value: true } }}                                       
                                />
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <label htmlFor="gender" className="col-md-2 col-form-label">
                                    Pejabat Penetap<span className="text-danger">*</span>
                                </label>
                                <Col md="4">
                                    <AvField
                                        type="text" 
                                        name="pejabat_penetap"
                                        id="pejabat_penetap"
                                        placeholder="Pejabat Penetap..."
                                        errorMessage="Masukkan Pejabat Penetap"
                                        // validate={{ required: { value: true } }}                                       
                                    />
                                </Col>
                            </Row>
                        </Col>
                        {/* <Col md="6"></Col> */}
                    </Row>
                    <hr />
                    <Row className="mb-3">
                        <Col md="6"><b>Unit Kerja Sekarang</b></Col>
                        <Col md="6"><b>Unit Kerja Baru</b></Col>
                    </Row>
                    <hr />
                    <div className="table-responsive">
                        <MKIDatatable
                            className={this.configDatatable.tableClass}
                            config={this.configDatatable}
                            records={this.state.rows}
                            columns={[
                                ...this.columns,
                            ]}
                            dynamic={true}
                            total_record={this.state.totalRow}
                            initial={{
                                ...this.state.filter,
                                pageSize: this.state.defaultSize // Menyimpan limit per halaman di sini
                            }}
                            onChange={(filter) => {
                                this.setState({
                                    loadingTable: true,
                                    filter: filter
                                }, function () {
                                    this.setTokenAPI()
                                });
                            }}
                            loading={this.state.loadingTable}
                        />

                        <ConfirmAlert
                            confirmTitle="Konfirmasi!"
                            confirmInfo="Apakah anda yakin akan membatalkan data usulan mutasi ini?"

                            loadingTitle="Mengambil data"
                            loadingInfo="Tunggu beberapa saat"

                            successTitle="Berhasil!"
                            successInfo="Data berhasil dihapus"

                            failedTitle="Gagal!"
                            failedInfo="Data gagal dihapus"

                            showConfirm={this.state.confirm}
                            showLoading={this.state.loading}
                            showSuccess={this.state.success}
                            showFailed={this.state.failed}

                            response={this.confirmResponse}
                        />
                        <ConfirmAlert
                            confirmTitle="Konfirmasi!"
                            confirmInfo="Apakah anda yakin akan Memproses data usulan mutasi ini?"

                            loadingTitle="Mengambil data"
                            loadingInfo="Tunggu beberapa saat"

                            successTitle="Berhasil!"
                            successInfo="Data berhasil diproses"

                            failedTitle="Gagal!"
                            failedInfo="Data gagal diproses"

                            showConfirm={this.state.confirmsubmit}
                            showLoading={this.state.loadingsubmit}
                            showSuccess={this.state.successsubmit}
                            showFailed={this.state.failedsubmit}

                            response={this.confirmResponseSubmit}
                            />
                        <ConfirmAlert
                            failedTitle="Perhatian!"
                            failedInfo="Harap lengkapi semua field: Nomor SK, Tanggal SK, TMT SK, dan Pejabat Penetap."
                            showFailed={this.state.errorwajib}
                            response={this.confirmResponseError}
                        />
                    </div>
                    {
                        (this.state.totalRow >0)?
                        <Button color="primary" type="submit" className="btn" >
                            Finalisasi
                        </Button>:''
                    }
                </AvForm>
            </>
        )
    }

}

export default TableSecondComponent